export const serviceTypeList = [
  { id: 1, name: "PBXBerry Demo" },
  { id: 2, name: "PBXBerry Básico" },
  { id: 3, name: "PBXBerry Pro" },
  { id: 4, name: "PBXBerry Pro + WhatsApp" },
  { id: 5, name: "PBXBerry Demo + Bitrix" },
  { id: 6, name: "PBXBerry Pro + Bitrix" },
];

export const roleOptions = [
  {
    value: 2,
    label: "Supervisor",
  },
  {
    value: 3,
    label: "Agente",
  },
  {
    value: 4,
    label: "Calidad",
  },
  {
    value: 10,
    label: "Supervisor restringido",
  },
];

export const defaultValue = {
  name: "",
  description: "",
  doc_sector_id: null,
  doc_service_id: null,
  has_ivr: false,
  ivr_audio: false,
  has_off_hours_message: false,
  off_hours_audio_file: null,
  off_hours_text: "",
  uses_breaks: false,
  breaks_description: "",
  extensions: [{ id: 1, name: "", extension: "", group: "" }],
  queues: [{ id: 1, name: "", strategy: "" }],
  agents: [{ id: 1, name: "", email: "", role: "" }],
  extensions_count: 0,
  queues_count: 0,
  agents_count: 0,
  whatsapp: {
    whatsapp_agents: 0,
    uses_bot: false,
    bot_schedule: "",
    bot_flow: "",
  },
  whatsapp_agents_count: 0,
};
